// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".terms-letter .terms-letter__banner[data-v-abb2ca38]{margin-top:40px;margin-bottom:40px}@media (max-width:767px){.terms-letter .terms-letter__banner[data-v-abb2ca38]{margin-top:30px;margin-bottom:30px}}", ""]);
// Exports
module.exports = exports;
